import { useQuery } from '@tanstack/react-query';
import { Cake } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '@/lib/api-client';
import { CardShell } from '../cards/card-shell';

function formatDay(birthDateStr: string): string {
  // backend devolve YYYY-MM-DD; extraimos o dia.
  const day = birthDateStr.slice(8, 10);
  return day || '--';
}

export function BirthdaysWidget() {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useQuery({
    queryKey: ['clients', 'stats', 'birthdays'],
    queryFn: () => apiClient.clientsStatsBirthdays(),
    staleTime: 1000 * 60,
  });

  const items = data?.items ?? [];
  const count = data?.count ?? 0;
  const preview = items.slice(0, 3);

  return (
    <CardShell title="Aniversariantes do mês" icon={Cake}>
      <div className="flex w-full flex-col gap-2">
        {isLoading ? (
          <div className="h-10 w-20 animate-pulse rounded bg-[var(--surface-muted)]" />
        ) : isError ? (
          <p className="text-xs text-[var(--fg-muted)]">
            Não foi possível carregar.
          </p>
        ) : count === 0 ? (
          <p className="text-xs text-[var(--fg-muted)]">
            Nenhum aniversariante este mês.
          </p>
        ) : (
          <>
            <div className="flex items-baseline gap-2">
              <span className="text-3xl font-semibold tracking-tight text-[var(--fg)]">
                {count}
              </span>
              <span className="text-[11px] text-[var(--fg-muted)]">
                pessoa{count > 1 ? 's' : ''}
              </span>
            </div>
            <ul className="flex flex-col gap-1 text-xs text-[var(--fg-muted)]">
              {preview.map((it) => (
                <li key={it.id} className="flex items-center gap-2">
                  <span className="inline-flex h-5 min-w-6 items-center justify-center rounded bg-[var(--surface-muted)] px-1 text-[10px] font-medium text-[var(--fg)]">
                    {formatDay(it.birthDate)}
                  </span>
                  <span className="truncate">{it.name}</span>
                </li>
              ))}
            </ul>
            {count > 3 && (
              <button
                type="button"
                onClick={() =>
                  navigate('/escritorio/clientes?aniversariantes=mes')
                }
                className="self-start text-[11px] font-medium text-[var(--accent)] hover:opacity-90"
              >
                Ver todos na lista
              </button>
            )}
          </>
        )}
      </div>
    </CardShell>
  );
}
